import { Model } from '@models/core/base.model';
import { Employee } from '@models/employee/employee.model';
import { Company } from '@models/company/company.model';
import { ApprovalInstanceStep } from '@models/approvals/approval-instance-step.model';
import { InstanceStatus } from '@app/enums';

export class ApprovalInstance extends Model {
    protected static _resource = 'approvals/instances';
    protected static _type = 'approvals.approvalInstances';
    protected static _version = 'v2';
    protected static _serializeAttributes = [
        'companyId',
        'status',
        'closingComments',
        'forcedAt',
        'forcedById',
        'createdAt',
        'updatedAt',
        'deletedAt',
    ];

    get status(): string {
        return this._attributes['status'];
    }

    get closingComments(): string {
        return this._attributes['closingComments'];
    }

    get forcedAt(): Date {
        return this._attributes['forcedAt'];
    }

    get forcedBy(): Employee {
        return this.hasOne(Employee, 'forcedBy');
    }

    get company(): Company {
        return this.hasOne(Company, 'company');
    }

    get steps(): ApprovalInstanceStep[] {
        return this.hasMany(ApprovalInstanceStep, 'steps');
    }

    isPending(): boolean {
        return this.status === InstanceStatus.Pending;
    }

    isApproved(): boolean {
        return this.forcedAt === null && this.status === InstanceStatus.Approved;
    }

    isDenied(): boolean {
        return this.forcedAt === null && this.status === InstanceStatus.Denied;
    }

    isForcedApproved(): boolean {
        return this.forcedAt !== null && this.status === InstanceStatus.Approved;
    }

    isForcedDenied(): boolean {
        return this.forcedAt !== null && this.status === InstanceStatus.Denied;
    }

    isResolved(): boolean {
        return this.status === InstanceStatus.Approved || this.status === InstanceStatus.Denied;
    }
}
